import dayjs from 'dayjs';
import _ from 'lodash';
import {useNavigate} from 'react-router-dom';
import {Flex, Card, Col, Row, Space, Typography} from 'antd';

import {colors} from 'pm-colors';

import {getCategoryIcon} from 'pm-utils';
import {useGetExpenseCategoriesQuery} from '../expenses/api';
import {RecurringExpense as RecurringExpenseType} from './types';

const {Text} = Typography;

type ExpenseProps = {
    item: RecurringExpenseType
}

function getFrequencyText(recurringExpense: RecurringExpenseType) {
    const {frequency, frequencyUnit, startDate} = recurringExpense;

    const formattedFrequency = frequency === 1 ? '' : `${frequency} `;
    const formattedUnit = frequency === 1 ? frequencyUnit : `${frequencyUnit}s`;

    return `Every ${formattedFrequency}${formattedUnit} since ${dayjs(startDate).format('DD.MM.YYYY')}`;
}

export function RecurringExpense({item}: Readonly<ExpenseProps>) {
    const navigate = useNavigate();

    const {data: expenseCategories} = useGetExpenseCategoriesQuery();
    const category = _.find(expenseCategories, {id: item.categoryId});

    if (_.isEmpty(category)) {
        return null
    }

    const categoryIconStyle = {
        color:           colors.white,
        backgroundColor: category.color,
    };

    const frequencyText = getFrequencyText(item);

    return (
        <Col xs={24} onClick={() => navigate(item.id as string)} className={'expense-item'}>
            <Card>
                <Row justify={'space-between'} align={'middle'}>
                    <Space size={5}>
                        <div className={'category-item__icon-background large'} style={categoryIconStyle}>
                            {getCategoryIcon(category.icon)}
                        </div>
                        <Flex gap={'small'} justify={'center'} vertical={true}>
                            <Text className={'p lh-1'}>{item.title || category.title}</Text>
                            <Text className={'sub lh-1'} disabled={true}>{frequencyText}</Text>
                        </Flex>
                    </Space>
                    <Text className={'p'}>-{item.amount.toFixed(2)}</Text>
                </Row>
            </Card>
        </Col>
    );
}
